import React, { Component } from 'react';
import { withStyles, createStyles, AppBar, Toolbar, Typography, CircularProgress, Grid, Card, CardHeader, Avatar, CardContent, CardActions, Button, Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, MenuItem, DialogActions, LinearProgress, IconButton, Tooltip, Badge, List, ListSubheader, Table, TableBody, TableRow, TablePagination, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import classNames from 'classnames';
import gql from 'graphql-tag';
import { connect, Provider } from 'react-redux';
import { Query, withApollo, Mutation, ApolloProvider } from 'react-apollo';
import { Link, navigate, Router } from '@reach/router';
import { withStyles as withStyles$2, createStyles as createStyles$1 } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar$1 from '@material-ui/core/AppBar';
import Toolbar$1 from '@material-ui/core/Toolbar';
import List$1 from '@material-ui/core/List';
import Typography$1 from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton$1 from '@material-ui/core/IconButton';
import '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import '@material-ui/icons/Image';
import CloudIcon from '@material-ui/icons/Cloud';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import '@material-ui/icons/Notifications';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ExitToApp from '@material-ui/icons/ExitToApp';
import HomeIcon from '@material-ui/icons/Home';
import '@material-ui/icons/Help';
import { graphqlQueryHelper, convertDateToSimpleDate, isBasicPropertyType, EntityListItem, withCoreContext, RenderEditor, CoreContext } from '@refract-cms/core';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { setContext } from 'apollo-link-context';
import { combineReducers, createStore } from 'redux';
import { action } from 'typesafe-actions';
import { RetryLink } from 'apollo-link-retry';
import { combineContainers } from 'combine-containers';
import Sort from '@material-ui/icons/Sort';
import Filter from '@material-ui/icons/FilterList';
import Refresh from '@material-ui/icons/Refresh';
import { compose } from 'recompose';
import Dialog$1 from '@material-ui/core/Dialog';
import Delete from '@material-ui/icons/Delete';
import ArrowBack from '@material-ui/icons/ArrowBack';
import 'graphql';
import Avatar$1 from '@material-ui/core/Avatar';
import Button$1 from '@material-ui/core/Button';
import FormControl$1 from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel$1 from '@material-ui/core/InputLabel';
import LockIcon from '@material-ui/icons/LockOutlined';
import Paper from '@material-ui/core/Paper';
import withStyles$1 from '@material-ui/core/styles/withStyles';
import Snackbar from '@material-ui/core/Snackbar';
import Close from '@material-ui/icons/Close';
import axios from 'axios';

const styles = (theme) => createStyles({
    padded: {
        padding: theme.spacing(3),
    },
    appBar: {
        bottom: 'auto',
        top: 64,
        background: theme.palette.background.default,
    },
    toolbar: {
        marginLeft: 240,
        alignItems: 'center',
        justifyContent: 'space-between',
        // minHeight: 40,
        // height: 40
    },
    page: {
        marginTop: 64,
    },
    actionButton: {
        marginLeft: theme.spacing(),
    },
});
const Page = ({ children, classes, disablePadding, title, actionComponents }) => (React.createElement("div", { className: classNames(classes.page, {
        [classes.padded]: !disablePadding,
    }) },
    React.createElement(AppBar, { position: "fixed", color: "default", className: classes.appBar, elevation: 0 },
        React.createElement(Toolbar, { className: classes.toolbar },
            React.createElement(Typography, { variant: "h5" }, title),
            React.createElement("div", null),
            React.createElement("div", null, actionComponents &&
                actionComponents.map((Component, index) => (React.createElement("span", { key: index, className: classes.actionButton }, Component)))))),
    children));
var Page$1 = withStyles(styles)(Page);

const createLinkComponent = (to) => React.forwardRef((props, ref) => React.createElement(Link, Object.assign({}, props, { to: to })));

class OverviewPage extends React.Component {
    render() {
        const { schemas, QUERY, routes } = this.props;
        return (React.createElement(Page$1, { title: "Overview" },
            React.createElement(Query, { query: QUERY }, ({ data, loading }) => {
                if (loading) {
                    return React.createElement(CircularProgress, null);
                }
                return (React.createElement(Grid, { container: true, spacing: 2 }, schemas.map((schema) => {
                    const count = data[`${schema.options.alias}Count`];
                    return (React.createElement(Grid, { key: schema.options.alias, item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2 },
                        React.createElement(Card, null,
                            React.createElement(CardHeader, { title: schema.options.displayName || schema.options.alias, avatar: React.createElement(Avatar, null, schema.options.icon ? React.createElement(schema.options.icon, null) : schema.options.alias[0].toUpperCase()) }),
                            React.createElement(CardContent, null,
                                React.createElement(Typography, null,
                                    "Total: ",
                                    count)),
                            React.createElement(CardActions, null,
                                React.createElement(Button, { color: "secondary", fullWidth: true, variant: "outlined", size: "small", component: createLinkComponent(routes.entity.list.createUrl(schema)) }, "Start editing")))));
                })));
            })));
    }
}
function mapStateToProps(state) {
    const countFields = state.config.schema.map((s) => `${s.options.alias}Count`).join(`
  `);
    const QUERY = gql `
  {
    ${countFields}
  }
  `;
    return {
        schemas: state.config.schema,
        QUERY,
        routes: state.router.routes,
    };
}
var OverviewPage$1 = connect(mapStateToProps)(OverviewPage);

const styles$1 = {
    iframe: {
        width: '100%',
        height: 'calc(100vh - 64px)',
        border: 'none',
        marginBottom: `-4px`,
    },
};
var Graphql = withStyles(styles$1)(({ serverUrl, classes }) => (React.createElement("iframe", { className: classes.iframe, src: `${serverUrl}/graphql-playground` })));

const CONFIGURE = '@@CMS/CONFIGURE';
const configure = (config, serverUrl) => {
    return action(CONFIGURE, {
        ...config,
        serverUrl,
    });
};

const defaultState = {
    serverUrl: '',
    schema: [],
};
function configReducer(state = defaultState, action) {
    switch (action.type) {
        case CONFIGURE: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default: {
            return state;
        }
    }
}

const SET_BASE_ROUTE = '@@CMS/SET_BASE_ROUTE';
const setBaseRoute = (baseRoute) => {
    const buildPath = (relativePath) => `${baseRoute}${relativePath}`.replace('//', '/');
    const routes = {
        root: {
            path: buildPath('/'),
            createUrl: () => buildPath('/'),
        },
        about: {
            path: buildPath('/about'),
            createUrl: () => buildPath('/about'),
        },
        graphql: {
            path: buildPath('/graphql-browser'),
            createUrl: () => buildPath('/graphql-browser'),
        },
        media: {
            path: buildPath('/media'),
            createUrl: () => buildPath('/media'),
        },
        files: {
            path: buildPath('/files'),
            createUrl: () => buildPath('/files'),
        },
        content: {
            path: buildPath(`/content/:alias?`),
            createUrl: (schema) => buildPath(`/content/${schema.options.alias}`),
        },
        entity: {
            list: {
                path: buildPath(`/content/:alias`),
                createUrl: (schema) => buildPath(`/content/${schema.options.alias}`),
            },
            edit: {
                path: buildPath(`/content/:alias/edit/:id`),
                createUrl: (args) => buildPath(`/content/${args.schema.options.alias}/edit/${args.id || ''}`),
            },
        },
    };
    return action(SET_BASE_ROUTE, routes);
};

const defaultState$1 = {
    routes: undefined,
};
function routesReducer(state = defaultState$1, action) {
    switch (action.type) {
        case SET_BASE_ROUTE: {
            const routes = action.payload;
            return {
                routes,
            };
        }
        default: {
            return state;
        }
    }
}

const authService = {
    isLoggedIn: () => 'access_token' in localStorage,
    setAccessToken: (accessToken) => localStorage.setItem('access_token', accessToken),
    removeAccessToken: () => localStorage.removeItem('access_token'),
    getAccessToken: () => localStorage.getItem('access_token'),
};

const SET_ACTIVE_USER_TOKEN = '@@CMS/SET_ACTIVE_USER_TOKEN';
function setActiveUserToken(token) {
    if (token) {
        authService.setAccessToken(token);
    }
    else {
        authService.removeAccessToken();
    }
    return action(SET_ACTIVE_USER_TOKEN, token);
}
const logout = () => {
    return setActiveUserToken(null);
};
// export const checkLocalStorageForAccessToken = () => setActiveUserToken(authService.getAccessToken());

function authReducer(state = {
    activeUserToken: authService.getAccessToken(),
}, action) {
    switch (action.type) {
        case SET_ACTIVE_USER_TOKEN: {
            return {
                ...state,
                activeUserToken: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}

const ADD_NOTIFICATION = '@@CMS/ADD_NOTIFICATION';
const REMOVE_NOTIFICATION = '@@CMS/REMOVE_NOTIFICATION';
const addNotification = (message) => {
    return action(ADD_NOTIFICATION, {
        message,
    });
};
const removeNotification = () => {
    return action(REMOVE_NOTIFICATION);
};

const defaultState$2 = {
    notification: undefined,
};
function notificationReducer(state = defaultState$2, action) {
    switch (action.type) {
        case ADD_NOTIFICATION: {
            return {
                ...state,
                notification: {
                    message: action.payload.message,
                },
            };
        }
        case REMOVE_NOTIFICATION: {
            return {
                ...state,
                notification: undefined,
            };
        }
        default: {
            return state;
        }
    }
}

const SET_ORDERBY = '@@CMS/ENTITIES/SET_ORDERBY';
const SET_ORDERBY_DIRECTION = '@@CMS/ENTITIES/SET_ORDERBY_DIRECTION';
const ADD_FILTER = '@@CMS/ENTITIES/ADD_FILTER';
const UPDATE_FILTER = '@@CMS/ENTITIES/UPDATE_FILTER';
const SET_PAGE = '@@CMS/ENTITIES/SET_PAGE';
const RESET_FILTERS = '@@CMS/ENTITIES/RESET_FILTERS';
const REMOVE_FILTER = '@@CMS/ENTITIES/REMOVE_FILTER';
const setOrderByField = (args) => {
    return action(SET_ORDERBY, args);
};
const setOrderByDirection = (args) => {
    return action(SET_ORDERBY_DIRECTION, args);
};
const addFilter = ({ schema }) => {
    const propertyKey = Object.keys(schema.properties)[0];
    return action(ADD_FILTER, {
        alias: schema.options.alias,
        schema,
        filter: {
            propertyKey,
            operater: 'EQ',
            value: schema.properties[propertyKey].type(),
        },
    });
};
const resetFilters = (args) => {
    return action(RESET_FILTERS, args);
};
const removeFilter = (args) => {
    return action(REMOVE_FILTER, args);
};
const updateFilter = (args) => {
    return action(UPDATE_FILTER, args);
};
const setPage = (args) => {
    return action(SET_PAGE, args);
};

var EntityActions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    SET_ORDERBY: SET_ORDERBY,
    SET_ORDERBY_DIRECTION: SET_ORDERBY_DIRECTION,
    ADD_FILTER: ADD_FILTER,
    UPDATE_FILTER: UPDATE_FILTER,
    SET_PAGE: SET_PAGE,
    RESET_FILTERS: RESET_FILTERS,
    REMOVE_FILTER: REMOVE_FILTER,
    setOrderByField: setOrderByField,
    setOrderByDirection: setOrderByDirection,
    addFilter: addFilter,
    resetFilters: resetFilters,
    removeFilter: removeFilter,
    updateFilter: updateFilter,
    setPage: setPage
});

const defaultState$3 = {};
function entityReducer(state = defaultState$3, action) {
    switch (action.type) {
        case SET_ORDERBY: {
            return {
                ...state,
                [action.payload.alias]: {
                    ...state[action.payload.alias],
                    orderByDirection: state[action.payload.alias] ? state[action.payload.alias].orderByDirection || 'ASC' : 'ASC',
                    orderByField: action.payload.orderByField,
                    currentPage: 0,
                },
            };
        }
        case ADD_FILTER: {
            return {
                ...state,
                [action.payload.alias]: {
                    ...state[action.payload.alias],
                    orderByDirection: state[action.payload.alias] ? state[action.payload.alias].orderByDirection || 'ASC' : 'ASC',
                    filters: [...state[action.payload.alias].filters, action.payload.filter],
                    currentPage: 0,
                },
            };
        }
        case UPDATE_FILTER: {
            const { schema } = action.payload;
            const newFilters = [...state[action.payload.alias].filters];
            if (action.payload.filter.propertyKey === state[action.payload.alias].filters[action.payload.index].propertyKey) {
                newFilters[action.payload.index] = action.payload.filter;
            }
            else {
                const type = schema.properties[action.payload.filter.propertyKey].type;
                newFilters[action.payload.index] = {
                    ...action.payload.filter,
                    value: type === Date ? convertDateToSimpleDate(new Date()) : type(),
                };
            }
            return {
                ...state,
                [action.payload.alias]: {
                    ...state[action.payload.alias],
                    filters: newFilters,
                    currentPage: 0,
                },
            };
        }
        case REMOVE_FILTER: {
            const { alias, index } = action.payload;
            const newFilters = [...state[action.payload.alias].filters.filter((f, i) => i !== index)];
            return {
                ...state,
                [alias]: {
                    ...state[alias],
                    filters: newFilters,
                    currentPage: 0,
                },
            };
        }
        case RESET_FILTERS: {
            const { alias } = action.payload;
            return {
                ...state,
                [alias]: {
                    ...state[alias],
                    filters: [],
                    currentPage: 0,
                },
            };
        }
        case SET_ORDERBY_DIRECTION: {
            return {
                ...state,
                [action.payload.alias]: {
                    ...state[action.payload.alias],
                    orderByDirection: action.payload.direction,
                    currentPage: 0,
                },
            };
        }
        case SET_PAGE: {
            return {
                ...state,
                [action.payload.alias]: {
                    ...state[action.payload.alias],
                    currentPage: action.payload.page,
                },
            };
        }
        case CONFIGURE: {
            return action.payload.schema.reduce((acc, schema) => {
                acc[schema.options.alias] = {
                    orderByDirection: schema.options.defaultSort ? schema.options.defaultSort.orderByDirection || 'ASC' : 'ASC',
                    orderByField: schema.options.defaultSort ? schema.options.defaultSort.orderByField : undefined,
                    filters: [],
                    currentPage: 0,
                    schema,
                    query: graphqlQueryHelper.getAllQueryWithAllFields(schema),
                };
                return acc;
            }, {});
        }
        default: {
            return state;
        }
    }
}

const rootReducer = combineReducers({
    config: configReducer,
    router: routesReducer,
    auth: authReducer,
    notification: notificationReducer,
    entity: entityReducer,
});

// import throttle from 'lodash/throttle';
const store = createStore(rootReducer);
// store.subscribe(
//   throttle(() => {
//     const state = store.getState();
//     localStorage.setItem('entityState', JSON.stringify(state.entity));
//   }, 1000)
// );

const retryLink = new RetryLink({
    delay: {
        initial: 300,
        max: Infinity,
        jitter: true,
    },
    attempts: {
        max: 25,
        retryIf: (error, _operation) => !!error,
    },
});
const createApolloClient = ({ serverUrl }) => {
    const httpLink = new HttpLink({ uri: `${serverUrl}/internal/graphql` });
    const withTokenLink = setContext((operation, { headers }) => Promise.resolve({
        headers: {
            ...headers,
            authorization: localStorage.getItem('access_token') || '',
        },
    }));
    const handleAuthErrorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
        if (graphQLErrors && graphQLErrors.some((err) => err.message === 'AuthenticationError')) {
            store.dispatch(logout());
        }
        if (networkError) {
            console.log({ networkError });
            switch (networkError.statusCode) {
                case 401: {
                    store.dispatch(logout());
                    break;
                }
            }
        }
        return forward(operation);
    });
    const link = ApolloLink.from([retryLink, withTokenLink, handleAuthErrorLink, httpLink]);
    const cache = new InMemoryCache({
        addTypename: false,
        dataIdFromObject: (o) => o._id,
    });
    return new ApolloClient({
        link,
        cache,
    });
};

const styles$2 = (theme) => createStyles({
    formControl: {
        marginBottom: theme.spacing(),
    },
});
const EntityListSortDialog = ({ classes, schema, onClose, open, filters, setOrderByDirection, setOrderByField, setOpened, }) => {
    return (React.createElement(Dialog, { open: open, onClose: onClose },
        React.createElement(DialogTitle, null, "Sort"),
        React.createElement(DialogContent, { style: { width: 400 } },
            React.createElement(FormControl, { className: classes.formControl, fullWidth: true },
                React.createElement(InputLabel, null, "Sort by"),
                React.createElement(Select, { value: filters.orderByField || '', onChange: (e) => setOrderByField({
                        alias: schema.options.alias,
                        orderByField: e.target.value,
                    }) },
                    React.createElement(MenuItem, { value: "" }, "None"),
                    Object.keys(schema.properties)
                        .filter((propertyKey) => schema.properties[propertyKey].type === String ||
                        schema.properties[propertyKey].type === Date ||
                        schema.properties[propertyKey].type === Number)
                        .map((propertyKey, index) => {
                        const propertyOptions = schema.properties[propertyKey];
                        return (React.createElement(MenuItem, { key: index, value: propertyKey }, propertyOptions.displayName || propertyKey));
                    }))),
            React.createElement(FormControl, { className: classes.formControl, fullWidth: true },
                React.createElement(InputLabel, null, "Direction"),
                React.createElement(Select, { value: filters.orderByDirection, onChange: (e) => setOrderByDirection({
                        alias: schema.options.alias,
                        direction: e.target.value,
                    }) },
                    React.createElement(MenuItem, { value: "ASC" }, "ASC"),
                    React.createElement(MenuItem, { value: "DESC" }, "DESC")))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => setOpened(false) }, "Done"))));
};
function mapStateToProps$1(state, ownProps) {
    const filters = state.entity[ownProps.schema.options.alias];
    return {
        filters,
    };
}
const mapDispatchToProps = { ...EntityActions };
var EntityListSortDialog$1 = compose(withStyles(styles$2), connect(mapStateToProps$1, mapDispatchToProps))(EntityListSortDialog);

const operatorDescriptions = [
    {
        operater: 'EQ',
        displayName: 'Equals',
    },
    {
        operater: 'NEQ',
        displayName: 'Not equal to',
    },
    {
        operater: 'GT',
        displayName: 'Greater than',
    },
    {
        operater: 'GTE',
        displayName: 'Greater than or equal to',
    },
    {
        operater: 'LTE',
        displayName: 'Less than or equal to',
    },
    {
        operater: 'LT',
        displayName: 'Less than',
    },
    {
        operater: 'IN',
        displayName: 'In',
    },
];

const styles$3 = (theme) => createStyles({
    formControl: {
        marginBottom: theme.spacing(),
    },
});
const EntityListFilterDialog = ({ classes, onClose, open, setOpened, schema, filters, addFilter, updateFilter, removeFilter, resetFilters, count, }) => {
    return (React.createElement(Dialog$1, { open: open, onClose: onClose, fullWidth: true, maxWidth: "md" },
        React.createElement(DialogTitle, null,
            "Filter ",
            count ? React.createElement(React.Fragment, null,
                "(",
                count,
                " matches)") : ''),
        React.createElement(DialogContent, null, filters.map((filter, index) => {
            const Editor = schema.properties[filter.propertyKey].editorComponent;
            return (React.createElement(Grid, { key: index, container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(FormControl, { className: classes.formControl, fullWidth: true },
                        React.createElement(InputLabel, null, "Property"),
                        React.createElement(Select, { value: filter.propertyKey, onChange: (e) => {
                                updateFilter({
                                    alias: schema.options.alias,
                                    index,
                                    filter: {
                                        ...filter,
                                        propertyKey: e.target.value,
                                    },
                                    schema,
                                });
                            } }, Object.keys(schema.properties)
                            .filter((propertyKey) => isBasicPropertyType(schema.properties[propertyKey].type))
                            .map((propertyKey) => (React.createElement(MenuItem, { key: propertyKey, value: propertyKey }, schema.properties[propertyKey].displayName || propertyKey)))))),
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(FormControl, { className: classes.formControl, fullWidth: true },
                        React.createElement(InputLabel, null, "Operater"),
                        React.createElement(Select, { value: filter.operater, onChange: (e) => {
                                updateFilter({
                                    alias: schema.options.alias,
                                    index,
                                    filter: {
                                        ...filter,
                                        operater: e.target.value,
                                    },
                                    schema,
                                });
                            } }, operatorDescriptions.map((operaterDescription) => (React.createElement(MenuItem, { key: operaterDescription.operater, value: operaterDescription.operater }, operaterDescription.displayName)))))),
                React.createElement(Grid, { item: true, xs: 4 },
                    React.createElement(Editor, { source: {}, serverUrl: "", propertyKey: filter.propertyKey, propertyOptions: schema.properties[filter.propertyKey], value: filter.value, setValue: (value) => {
                            updateFilter({
                                alias: schema.options.alias,
                                index,
                                filter: {
                                    ...filter,
                                    value,
                                },
                                schema,
                            });
                        } })),
                React.createElement(Grid, { item: true, xs: 2 },
                    React.createElement(Button, { style: { marginTop: 11 }, fullWidth: true, onClick: () => removeFilter({ alias: schema.options.alias, index }) }, "Remove filter"))));
        })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: "secondary", onClick: () => {
                    addFilter({ schema });
                } }, "Add filter"),
            React.createElement(Button, { onClick: () => resetFilters({ alias: schema.options.alias }) }, "Clear"),
            React.createElement(Button, { onClick: () => setOpened(false) }, "Done"))));
};
function mapStateToProps$2(state, ownProps) {
    return {
        filters: state.entity[ownProps.schema.options.alias].filters,
    };
}
const mapDispatchToProps$1 = { ...EntityActions };
var EntityListFilterDialog$1 = compose(withStyles(styles$3), connect(mapStateToProps$2, mapDispatchToProps$1))(EntityListFilterDialog);

function buildEntityListQueryOptions(state) {
    const query = graphqlQueryHelper.getAllQueryWithAllFields(state.schema);
    let transformedFilter = {};
    let transformedSort = {};
    if (state.filters) {
        transformedFilter = {
            AND: state.filters.map((f) => {
                return {
                    [f.propertyKey]: {
                        [f.operater]: f.value,
                    },
                };
            }),
        };
    }
    if (state.orderByDirection && state.orderByField) {
        transformedSort = {
            [state.orderByField]: state.orderByDirection,
        };
    }
    return {
        query,
        variables: {
            filter: transformedFilter,
            sort: transformedSort,
            pagination: {
                skip: state.currentPage * 10,
                limit: 10,
            },
        },
    };
}

const styles$4 = (theme) => createStyles({
    textLink: {
        cursor: 'pointer',
        color: theme.palette.secondary.main,
        '&:hover': {
            textDecoration: 'underline',
        },
    },
});
class EntitiesList extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            sortDialogOpen: false,
            filterDialogOpen: false,
            count: undefined,
        };
    }
    render() {
        const { routes, entitySchema, classes, entityItemState, setPage } = this.props;
        const { query, variables } = buildEntityListQueryOptions(entityItemState);
        return (React.createElement("div", null,
            React.createElement(Query, { query: query, variables: variables, displayName: `${entitySchema.options.alias}_list`, notifyOnNetworkStatusChange: true, fetchPolicy: "cache-and-network", onCompleted: (data) => {
                    const count = !data.loading && data ? data.count : undefined;
                    const lastFetchAlias = entitySchema.options.alias;
                    if (count !== this.state.count) {
                        this.setState({ count, lastFetchAlias });
                    }
                } }, ({ loading, data, refetch, variables }) => {
                const items = data.items || [];
                if (loading && this.state.lastFetchAlias !== entitySchema.options.alias) {
                    return React.createElement(LinearProgress, null);
                }
                return (React.createElement(Page$1, { title: entitySchema.options.displayName || entitySchema.options.alias, actionComponents: !entitySchema.options.maxOne
                        ? [
                            React.createElement(IconButton, { key: "refresh", disabled: loading, onClick: () => refetch(variables) },
                                React.createElement(Refresh, null)),
                            React.createElement(IconButton, { key: "sort", onClick: () => this.setState({ sortDialogOpen: true }) },
                                React.createElement(Tooltip, { title: "Sort" },
                                    React.createElement(Badge, { variant: "dot", badgeContent: entityItemState.orderByField ? 1 : 0, color: "secondary" },
                                        React.createElement(Sort, null)))),
                            React.createElement(IconButton, { key: "filter", onClick: () => this.setState({ filterDialogOpen: true }) },
                                React.createElement(Tooltip, { title: "Filters" },
                                    React.createElement(Badge, { badgeContent: entityItemState.filters.length, color: "secondary" },
                                        React.createElement(Filter, null)))),
                            React.createElement(Button, { key: "new", variant: "contained", color: "primary", component: createLinkComponent(routes.entity.edit.createUrl({
                                    id: 'new',
                                    schema: entitySchema,
                                })) }, "Add new"),
                        ]
                        : undefined }, !entitySchema.options.maxOne ? (React.createElement("div", null,
                    React.createElement(List, { subheader: entityItemState && entityItemState.orderByField && entityItemState.orderByDirection ? (React.createElement(ListSubheader, { className: classes.textLink, onClick: () => this.setState({ sortDialogOpen: true }) },
                            "Sorted by",
                            ' ',
                            entitySchema.properties[entityItemState.orderByField]
                                .displayName,
                            ", ",
                            entityItemState.orderByDirection)) : undefined }, items.map((item) => {
                        return (React.createElement(EntityListItem, { key: item._id, component: createLinkComponent(routes.entity.edit.createUrl({
                                id: item._id,
                                schema: entitySchema,
                            })), button: true, entity: item, schema: entitySchema }));
                    })),
                    React.createElement(Table, null,
                        React.createElement(TableBody, null,
                            React.createElement(TableRow, null,
                                React.createElement(TablePagination, { page: entityItemState.currentPage, count: data.count, onChangePage: (e, page) => {
                                        setPage({
                                            alias: entitySchema.options.alias,
                                            page,
                                        });
                                    }, rowsPerPage: 10 })))))) : (React.createElement("div", null,
                    React.createElement(Button, { variant: "contained", color: "primary", component: (props) => (React.createElement(Link, Object.assign({ to: items.length === 0
                                ? routes.entity.edit.createUrl({
                                    id: 'new',
                                    schema: entitySchema,
                                })
                                : routes.entity.edit.createUrl({
                                    id: items[0]._id,
                                    schema: entitySchema,
                                }) }, props))) },
                        "Edit ",
                        entitySchema.options.displayName || entitySchema.options.alias)))));
            }),
            React.createElement(EntityListSortDialog$1, { schema: entitySchema, open: this.state.sortDialogOpen, onClose: () => this.setState({ sortDialogOpen: false }), setOpened: (opened) => this.setState({ sortDialogOpen: opened }) }),
            React.createElement(EntityListFilterDialog$1, { schema: entitySchema, open: this.state.filterDialogOpen, onClose: () => this.setState({ filterDialogOpen: false }), setOpened: (opened) => this.setState({ filterDialogOpen: opened }), count: this.state.count })));
    }
}
const mapDispatchToProps$2 = { ...EntityActions };
function mapStateToProps$3(state, ownProps) {
    const entitySchema = state.config.schema.find((s) => s.options.alias === ownProps.alias);
    const entityItemState = state.entity[entitySchema.options.alias];
    return {
        schema: state.config.schema,
        routes: state.router.routes,
        entitySchema,
        entityItemState,
    };
}
var EntityList = combineContainers(connect(mapStateToProps$3, mapDispatchToProps$2), withApollo, withStyles(styles$4))(EntitiesList);

const provide = (store) => (Component) => (props) => (React.createElement(Provider, { store: store },
    React.createElement(Component, Object.assign({}, props))));

const styles$5 = (theme) => createStyles({
    card: {
        margin: theme.spacing(),
    },
    propertyEditor: {
        marginBottom: theme.spacing(4),
    },
    root: {
        paddingBottom: 70,
    },
});
class EntityForm extends Component {
    constructor(props) {
        super(props);
        const updateValues = {};
        if (props.newEntity) {
            Object.keys(props.schema.properties).forEach((propertyKey) => {
                const propertyOptions = props.schema.properties[propertyKey];
                updateValues[propertyKey] = propertyOptions.defaultValue;
            });
            this.state = {
                updateValues,
                loading: false,
            };
        }
        else {
            this.state = {
                updateValues,
                loading: true,
            };
        }
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.back = this.back.bind(this);
    }
    componentDidMount() {
        const { schema, id, newEntity, client } = this.props;
        if (!newEntity) {
            client
                .query({
                query: graphqlQueryHelper.getByIdQueryWithAllFields(schema, id),
            })
                .then(({ data, errors }) => {
                if (!errors) {
                    this.setState({
                        loading: false,
                        updateValues: data.item,
                    });
                }
            });
        }
    }
    render() {
        const { schema, classes, context } = this.props;
        return this.state.loading ? (React.createElement(LinearProgress, null)) : (React.createElement("div", { className: classes.root },
            React.createElement(Page$1, { title: schema.options.displayName || schema.options.alias, actionComponents: [
                    React.createElement(IconButton, { key: "back", onClick: this.back },
                        React.createElement(ArrowBack, null)),
                    React.createElement(IconButton, { key: "delete", onClick: this.delete },
                        React.createElement(Delete, null)),
                    React.createElement(Button, { key: "save", color: "primary", variant: "contained", onClick: this.save }, "Save"),
                ] },
                React.createElement(Grid, { justify: "center", container: true },
                    React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 10, lg: 8, xl: 7 },
                        React.createElement("div", { className: classes.card }, Object.keys(schema.properties).map((propertyKey, index) => {
                            const propertyOptions = schema.properties[propertyKey];
                            return (React.createElement("div", { key: index, className: classes.propertyEditor },
                                React.createElement(Grid, { container: true, spacing: 2 },
                                    React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3, xl: 3 },
                                        React.createElement(Typography, { variant: "subtitle1", gutterBottom: true }, propertyOptions.displayName || propertyKey)),
                                    React.createElement(Grid, { item: true, xs: 12, sm: 12, md: 9, lg: 9, xl: 9 },
                                        React.createElement(RenderEditor, { source: this.state.updateValues, serverUrl: context.serverUrl, setValue: (value) => {
                                                this.setState({
                                                    updateValues: {
                                                        ...this.state.updateValues,
                                                        [propertyKey]: value,
                                                    },
                                                });
                                            }, value: this.state.updateValues[propertyKey], propertyKey: propertyKey, propertyOptions: propertyOptions })))));
                        })))))));
    }
    save() {
        const { schema } = this.props;
        this.setState({ loading: true }, () => {
            this.props
                .saveEntity(this.state.updateValues)
                .then(() => {
                this.back();
                this.props.addNotification(`Successfully saved ${schema.options.displayName || schema.options.alias}.`);
            })
                .catch(() => {
                this.setState({ loading: false });
            });
        });
    }
    delete() {
        if (window.confirm('Are you sure you want to delete?')) {
            const { client, schema, entityItemState, id } = this.props;
            const refetchQueryOptions = buildEntityListQueryOptions(entityItemState);
            this.setState({ loading: true }, () => {
                client
                    .mutate({
                    refetchQueries: [refetchQueryOptions],
                    mutation: gql(`
      mutation {
        ${this.props.alias}RemoveById(id: "${this.props.id}")
      }`),
                })
                    .then(() => {
                    this.back();
                    this.props.addNotification(`Successfully deleted ${schema.options.displayName || schema.options.alias}.`);
                })
                    .catch(() => {
                    this.setState({ loading: false });
                });
            });
        }
    }
    back() {
        navigate(this.props.routes.entity.list.createUrl(this.props.schema));
    }
}
function mapStateToProps$4(state, ownProps) {
    const entitySchema = state.config.schema.find((s) => s.options.alias === ownProps.alias);
    const entityItemState = state.entity[entitySchema.options.alias];
    return {
        routes: state.router.routes,
        schema: entitySchema,
        entityItemState,
    };
}
const mapDispatchToProps$3 = {
    addNotification,
};
var EntityForm$1 = combineContainers(withApollo, connect(mapStateToProps$4, mapDispatchToProps$3), withStyles(styles$5), withCoreContext)(EntityForm);

const EditEntity = ({ alias, id, client, schema, entityItemState }) => {
    const refetchQueryOptions = buildEntityListQueryOptions(entityItemState);
    const createMutation = gql(`
  mutation save($record: ${schema.options.alias}Input!){
    update: ${alias}Create(record: $record) {
      _id
      ${graphqlQueryHelper.buildPropertiesFromSchema(schema)}
    }
  }
  `);
    const updateMutation = gql(`
  mutation save($record: ${schema.options.alias}Input!){
    update: ${alias}Update(record: $record) {
      _id
      ${graphqlQueryHelper.buildPropertiesFromSchema(schema)}
    }
  }
  `);
    const newEntity = !id || id === 'new';
    const mutation = newEntity ? createMutation : updateMutation;
    return (React.createElement(Mutation, { mutation: mutation, refetchQueries: [refetchQueryOptions] }, (save, mutationResult) => {
        return (React.createElement(EntityForm$1, { alias: alias, newEntity: newEntity, id: id, saveEntity: (record) => {
                const recordWithNullInsteadOfUndefined = Object.keys(record).reduce((acc, recordKey) => {
                    acc[recordKey] = record[recordKey] === undefined ? null : record[recordKey];
                    return acc;
                }, {});
                // delete recordWithNullInsteadOfUndefined['__typename'];
                return new Promise((resolve, reject) => {
                    save({
                        variables: {
                            record: recordWithNullInsteadOfUndefined,
                        },
                        update: (proxy, updateResult) => {
                            const responseObject = updateResult.data.update;
                            client.cache.writeData({
                                id: responseObject._id,
                                data: responseObject,
                            });
                            resolve();
                        },
                    });
                });
            } }));
    }));
};
function mapStateToProps$5(state, ownProps) {
    const entitySchema = state.config.schema.find((s) => s.options.alias === ownProps.alias);
    const entityItemState = state.entity[entitySchema.options.alias];
    return {
        routes: state.router.routes,
        schema: entitySchema,
        entityItemState,
    };
}
var EditEntity$1 = combineContainers(connect(mapStateToProps$5), withApollo)(EditEntity);

const generateAccessTokenMutation = gql(`
  mutation generateAccessToken($username: String!, $password: String!) {
    generateAccessToken(username: $username, password: $password)
  }
`);
const styles$6 = (theme) => createStyles({
    main: {
        width: 'auto',
        display: 'block',
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(3 * 2))]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    },
    avatar: {
        margin: theme.spacing(),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(),
    },
    submit: {
        marginTop: theme.spacing(3),
    },
});
class Auth extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            username: '',
            password: '',
            loggingIn: false,
        };
        this.onChange = (name) => (e) => this.setState({ [name]: e.target.value });
    }
    render() {
        const { classes } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(CssBaseline, null),
            React.createElement("main", { className: classes.main },
                React.createElement(Paper, { className: classes.paper },
                    React.createElement(Avatar$1, { className: classes.avatar },
                        React.createElement(LockIcon, null)),
                    React.createElement(Typography$1, { variant: "h5" }, "Sign in"),
                    React.createElement("form", { className: classes.form, onSubmit: (e) => {
                            e.preventDefault();
                            const { username, password } = this.state;
                            this.setState({
                                loggingIn: true,
                                error: undefined,
                            });
                            fetch(`${this.props.config.serverUrl}/login`, {
                                method: 'POST',
                                body: JSON.stringify({
                                    username,
                                    password,
                                }),
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                            })
                                .then((res) => {
                                console.log({ res });
                                return res.json();
                            })
                                .then(({ token }) => {
                                console.log({ token });
                                this.props.setActiveUserToken(token);
                                this.setState({
                                    isLoading: false,
                                });
                                this.props.client.resetStore();
                            })
                                .catch(() => {
                                this.setState({
                                    isLoading: false,
                                    error: 'Login failed',
                                });
                            });
                        } },
                        this.state.error && React.createElement(Typography$1, null, this.state.error),
                        React.createElement(FormControl$1, { margin: "normal", required: true, fullWidth: true },
                            React.createElement(InputLabel$1, { htmlFor: "username" }, "Username"),
                            React.createElement(Input, { value: this.state.username, onChange: this.onChange('username'), id: "username", name: "username", autoFocus: true })),
                        React.createElement(FormControl$1, { margin: "normal", required: true, fullWidth: true },
                            React.createElement(InputLabel$1, { htmlFor: "password" }, "Password"),
                            React.createElement(Input, { value: this.state.password, onChange: this.onChange('password'), name: "password", type: "password", id: "password", autoComplete: "current-password" })),
                        React.createElement(Button$1, { type: "submit", fullWidth: true, variant: "contained", color: "primary", className: classes.submit }, "Sign in"))))));
    }
}
function mapStateToProps$6(state) {
    return {
        config: state.config,
    };
}
const mapDispatchToProps$4 = {
    setActiveUserToken,
};
var Auth$1 = combineContainers(connect(mapStateToProps$6, mapDispatchToProps$4), withStyles$1(styles$6), withApollo)(Auth);

const styles$7 = (theme) => createStyles$1({
    close: {
        padding: theme.spacing(0.5),
    },
});
const Notifications = ({ notification, addNotification, removeNotification }) => (React.createElement(Snackbar, { anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    }, open: Boolean(notification), autoHideDuration: 6000, onClose: () => setTimeout(removeNotification, 1), message: notification ? notification.message : '', action: [
        React.createElement(IconButton$1, { key: "close", "aria-label": "Close", color: "inherit", onClick: removeNotification },
            React.createElement(Close, null)),
    ] }));
function mapStateToProps$7(state) {
    return state.notification;
}
const mapDispatchToProps$5 = {
    addNotification,
    removeNotification,
};
var Notifications$1 = combineContainers(withStyles$2(styles$7), connect(mapStateToProps$7, mapDispatchToProps$5))(Notifications);

const drawerWidth = 240;
const styles$8 = (theme) => createStyles({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
    // marginLeft: drawerWidth,
    // width: `calc(100% - ${drawerWidth}px)`,
    // transition: theme.transitions.create(['width', 'margin'], {
    //   easing: theme.transitions.easing.sharp,
    //   duration: theme.transitions.duration.enteringScreen
    // })
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        background: theme.palette.background.default,
    },
    chartContainer: {
        marginLeft: -22,
    },
    tableContainer: {
        height: 320,
    },
    h5: {
        marginBottom: theme.spacing(2),
    },
});
class Dashboard extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: true,
        };
        this.handleDrawerOpen = () => {
            this.setState({ open: true });
        };
        this.handleDrawerClose = () => {
            this.setState({ open: false });
        };
    }
    componentDidMount() {
        const { config, serverUrl, rootPath, configure, setBaseRoute } = this.props;
        setBaseRoute(rootPath);
        configure(config, serverUrl);
    }
    render() {
        const { classes, config, serverUrl, routes, isLoggedIn, logout, homePageUrl } = this.props;
        if (!routes) {
            return React.createElement(CircularProgress, null);
        }
        return (React.createElement(CoreContext.Provider, { value: {
                serverUrl,
                getPluginAxios: (pluginAlias) => {
                    const client = axios.create({
                        baseURL: `${serverUrl}/plugins/${pluginAlias}`,
                        headers: {
                            Authorization: 'Bearer ' + authService.getAccessToken(),
                        },
                    });
                    return client;
                },
                // fileService: new FileService(serverUrl)
            } },
            React.createElement(ApolloProvider, { client: createApolloClient({ serverUrl }) },
                React.createElement(Notifications$1, null),
                React.createElement(CssBaseline, null),
                !isLoggedIn ? (React.createElement(Router, null,
                    React.createElement(Auth$1, { default: true, path: "/" }))) : (React.createElement("div", { className: classes.root },
                    React.createElement(AppBar$1, { position: "absolute", className: classNames(classes.appBar, this.state.open && classes.appBarShift) },
                        React.createElement(Toolbar$1, { disableGutters: !this.state.open, className: classes.toolbar },
                            React.createElement(IconButton$1, { color: "inherit", "aria-label": "Open drawer", onClick: this.handleDrawerOpen, className: classNames(classes.menuButton, this.state.open && classes.menuButtonHidden) },
                                React.createElement(MenuIcon, null)),
                            React.createElement(Typography$1, { variant: "h6", color: "inherit", noWrap: true, className: classes.title }, "Content Dashboard"),
                            homePageUrl && (React.createElement(Tooltip, { title: "Go to home page", color: "secondary" },
                                React.createElement(IconButton$1, { href: homePageUrl, color: "inherit" },
                                    React.createElement(HomeIcon, null)))))),
                    React.createElement(Drawer, { variant: "permanent", classes: {
                            paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
                        }, open: this.state.open },
                        React.createElement("div", { className: classes.toolbarIcon },
                            React.createElement(IconButton$1, { onClick: this.handleDrawerClose },
                                React.createElement(ChevronLeftIcon, null))),
                        React.createElement(Divider, null),
                        React.createElement(List$1, null,
                            React.createElement(ListItem, { button: true, component: createLinkComponent(routes.root.createUrl()) },
                                React.createElement(ListItemIcon, null,
                                    React.createElement(DashboardIcon, null)),
                                React.createElement(ListItemText, { primary: "Overview" })),
                            React.createElement(ListItem, { button: true, component: createLinkComponent(routes.graphql.createUrl()) },
                                React.createElement(ListItemIcon, null,
                                    React.createElement(CloudIcon, null)),
                                React.createElement(ListItemText, { primary: "GraphQL playground" }))),
                        React.createElement(Divider, null),
                        React.createElement(List$1, null, config.schema.map((schema) => {
                            return (React.createElement(ListItem, { key: schema.options.alias, button: true, component: createLinkComponent(routes.entity.list.createUrl(schema)) },
                                schema.options.icon && (React.createElement(ListItemIcon, null,
                                    React.createElement(schema.options.icon, null))),
                                React.createElement(ListItemText, { primary: schema.options.displayName || schema.options.alias })));
                        })),
                        React.createElement(Divider, null),
                        React.createElement(List$1, null,
                            React.createElement(ListItem, { button: true, onClick: logout },
                                React.createElement(ListItemIcon, null,
                                    React.createElement(ExitToApp, null)),
                                React.createElement(ListItemText, { primary: "Logout" })))),
                    React.createElement("main", { className: classes.content },
                        React.createElement("div", { className: classes.appBarSpacer }),
                        React.createElement(Router, null,
                            React.createElement(OverviewPage$1, { path: routes.root.path }),
                            React.createElement(Graphql, { path: routes.graphql.path, serverUrl: serverUrl }),
                            React.createElement(EntityList, { path: routes.entity.list.path }),
                            React.createElement(EditEntity$1, { path: routes.entity.edit.path }))))))));
    }
}
function mapStateToProps$8(state) {
    return {
        entities: state.config.schema,
        routes: state.router.routes,
        isLoggedIn: Boolean(state.auth.activeUserToken),
    };
}
const mapDispatchToProps$6 = {
    setBaseRoute,
    configure,
    logout,
};
var Dashboard$1 = provide(store)(combineContainers(connect(mapStateToProps$8, mapDispatchToProps$6), withStyles$2(styles$8))(Dashboard));

const createDashboard = (dashboardProps) => (props) => React.createElement(Dashboard$1, Object.assign({ rootPath: getBaseRoute(props) }, dashboardProps));
function getBaseRoute(props) {
    const { path, match } = props;
    if (path) {
        return path;
    }
    else if (match) {
        return match.path;
    }
    else {
        return '/';
    }
}

export { Dashboard$1 as Dashboard, createDashboard };
//# sourceMappingURL=index.js.map
